import {
  getFirstResultItem,
  getResultMessage,
  isSuccessfulResult,
} from './clientEntryContracts';

export const CLIENT_ACTIVE_SESSION_ITEM_NAME = 'ClientCommandWorkspace';

export const CLIENT_ACTIVE_SESSION_OPERATIONS = Object.freeze({
  load: 'LoadClientActiveSessions',
  revoke: 'RevokeClientActiveSession',
});

export const CLIENT_ACTIVE_SESSION_CATEGORIES = Object.freeze({
  appUsers: 1,
  mcpServerConnections: 2,
});

export const buildClientActiveSessionRequest = ({
  clientId,
  currentEnvironment,
  category,
  searchText = '',
  page = 0,
  pageSize = 50,
  selectedSession = null,
}) => ({
  ClientId: clientId,
  CurrentEnvironment: currentEnvironment,
  ActiveSessionsRequest: {
    Category: category,
    SearchText: String(searchText || '').trim(),
    Page: Math.max(0, Number(page || 0)),
    PageSize: Math.min(200, Math.max(1, Number(pageSize || 50))),
    SessionId: selectedSession?.SessionId
      ?? selectedSession?.sessionId
      ?? null,
    SessionKind: selectedSession?.SessionKind
      ?? selectedSession?.sessionKind
      ?? 0,
  },
});

export const runClientActiveSessionOperation = async (
  manager,
  operationName,
  item,
  fallbackMessage,
) => {
  if (!manager?.RunOperation) throw new Error(fallbackMessage);
  const result = await manager.RunOperation({
    operationName,
    item,
    isItem: true,
    isWarning: true,
    supressAllErrors: false,
  });
  if (!isSuccessfulResult(result)) {
    throw new Error(getResultMessage(result, fallbackMessage));
  }
  return {
    result,
    workspace: getFirstResultItem(result),
  };
};
